import type { SearchParams } from '@aviata/platform-client';
import type { flightEntity } from 'freedom-shared';
import type { RouteParamsGeneric } from 'vue-router';
import { dateUtils, ticketDetails } from 'shared';

type ExtendedSearchParams = SearchParams & {
  dep: string;
  arr: string;
  dates: string[];
  isYouth: boolean;
};

export const getLinkTitle = (
  offer: flightEntity.types.MappedOffer | undefined,
  params: ExtendedSearchParams | null,
) => {
  if (!offer?.flights?.length) {
    return '';
  }

  const directionParts: string[] = [];

  for (const flight of offer.flights) {
    const { startCity, endCity } = ticketDetails.lib.getSegmentsData(flight);
    directionParts.push(`${startCity} — ${endCity}`);
  }

  const direction = directionParts.join(', ');

  if (!params?.dates?.length) {
    return direction;
  }

  const datesStr =
    params.dates.length === 1
      ? dateUtils.getVerbalDate(params.dates[0])
      : params.dates.map(d => dateUtils.getVerbalDate(d)).join(' – ');

  return `${direction}, ${datesStr}`;
};

export const getLinkPath = (
  offer: flightEntity.types.MappedOffer | undefined,
  params: RouteParamsGeneric,
) => {
  const hash = (offer?.$meta as { hash?: string } | undefined)?.hash;

  if (!offer || !hash) {
    return undefined;
  }

  return `/search/${params.hashCode}/deep_link/details/${hash}`;
};
